export enum ProductTypeEnum {
    Hub = 1,
    Repeater = 2,
    PetDoorConnect = 3,
    FeederConnect = 4,
    CatFlapConnect = 6,
    PoseidonConnect = 8,
}
